import { render } from "./PollCard.vue?vue&type=template&id=cc8f4de2&scoped=true"
import script from "./PollCard.vue?vue&type=script&lang=js"
export * from "./PollCard.vue?vue&type=script&lang=js"

import "./PollCard.vue?vue&type=style&index=0&id=cc8f4de2&scoped=true&lang=css"

import exportComponent from "/working_dir/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-cc8f4de2"]])

export default __exports__